import useTaxCustomer from '../taxcontext/useTaxCustomer'
import CustomerContextSelector from '../taxcontext/CustomerContextSelector'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
  useGetTaxpayersQuery,
  makeTaxpayerSelectors,
} from './taxpayersApiSlice'
import TaxPayerTable from './components/TaxPayerTable'

const TaxPayersList = () => {
  // keep args memoized so selector factory and query cache key stay stable
  const customerId = useTaxCustomer()
  const queryArgs = useMemo(() => ({ customer_id: customerId }), [customerId])

  const {
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetTaxpayersQuery(queryArgs, { skip: !customerId })

  const taxpayersSelectors = useMemo(
    () => makeTaxpayerSelectors(queryArgs),
    [queryArgs]
  )

  const taxpayerIds = useSelector(taxpayersSelectors.selectTaxpayerIds)
  const total = useSelector(taxpayersSelectors.selectTotal)

  let content = null

  if (isLoading) {
    content = (
      <div className="rounded-xl border border-slate-200 bg-white p-4 text-sm text-slate-600 shadow-sm">
        Loading taxpayers...
      </div>
    )
  }

  if (isError) {
    content = (
      <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700 shadow-sm">
        {error?.data?.message || error?.error || 'Failed to load taxpayers.'}
      </div>
    )
  }

  if (customerId && isSuccess) {
    content = (
      <TaxPayerTable
        taxpayerIds={taxpayerIds}
        total={total}
        queryArgs={queryArgs}
      />
    )
  }

  return (
    <section className="space-y-4">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-xl font-semibold text-slate-800">
              Taxpayers
            </h1>
            <p className="text-sm text-slate-500">
              Master list of taxpayers available in your current scope.
            </p>
          </div>

          <div className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-sm font-medium text-slate-700">
            Total: {total}
          </div>
        </div>
      </div>

      <CustomerContextSelector />
      {customerId ? content : <p className="text-sm text-slate-600">Pilih customer di atas untuk melihat wajib pajak.</p>}
    </section>
  )
}

export default TaxPayersList